export default "__VITE_ASSET__D2o3vQKy__"